import styles from "./styles/Referral.module.css";
import { Fragment, useState } from "react";
import { ReactComponent as OkSvg } from "./styles/img/ok.svg";
import { ReactComponent as NotokSvg } from "./styles/img/not_ok.svg";
import { ReactComponent as CopySvg } from "./styles/img/CopySimple.svg";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { submitCaptcha } from "../../../Utils/captcha";
import config from "../../../config";
import { Button } from "antd";
import { useEffect } from "react";
import { UserData } from "../../../Context/DataContext";

const base_url = config.base_url;
/*
  `onInvited` fires once an invitation has actually been accepted by the
  server. The customer list on My Customers is loaded from a different
  endpoint than the referral data refreshed below, so without being told it
  went on showing the table as it was when the page opened -- the partner
  invited somebody and nothing happened on screen.
*/
function ReferralCodesSection({
  setReferralData,
  referralData,
  masterCode,
  onInvited,
}) {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ReferralContent
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  const [loading, setLoading] = useState(false);
  const userData = UserData();

  const [referralEmail, setReferralEmail] = useState("");
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [invalidEmailFormat, setInvalidEmailFormat] = useState(false);
  const [emailInputTouched, setEmailInputTouched] = useState(false);
  const [showTextCopied, setShowTextCopied] = useState(false);
  const [userAlreadyInvited, setUserAlreadyInvited] = useState(false);
  const [timer, setTimer] = useState(undefined);
  //ben here is the reward status, I just do not want to manipulate the original variable names in assetsTable
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.ReferralContent);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    // This effect will run when the component mounts or when timeoutId changes
    return () => {
      // Cleanup function to clear the timeout when the component unmounts or timeoutId changes
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  const setNewTimeout = () => {
    // Clear the existing timeout if it exists

    if (timer) {
      clearTimeout(timer);
    }

    setTimer(
      setTimeout(() => {
        setEmailInputTouched(false);
        // Your timeout callback function
      }, 3000)
    ); // 5000 milliseconds = 5 seconds
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (userData.referralData.ownedCoupons.length === 0) {
      console.log("user does no have a coupon code");
      return;
    }

    setEmailInputTouched(true);
    setEmailInvalid(false);
    setLoading(true);
    setInvalidEmailFormat(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(referralEmail)) {
      setInvalidEmailFormat(true);
      setLoading(false);
      return;
    }
    setEmailInvalid(false);

    const token = await submitCaptcha();
    fetch(base_url + "user/referral/invite", {
      method: "POST",
      mode: "cors",
      body: `email=${referralEmail}&token=${token}&code=${referralData?.ownedCoupons[0]}`,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then(async (res) => {
        // if (res.statusText === "Too Many Requests") {
        //   setEmailInvalid(true);
        //   setLoading(false);
        //   return;
        // }
        if (res.status === 429) {
          await res
            .json()
            .then((data) => {
              if (data?.ErrorText === "Duplicated") {
                setUserAlreadyInvited(true);
                setTimeout(() => {
                  setUserAlreadyInvited(false);
                }, 3000);
              } else {
                setEmailInvalid(true);
                setLoading(false);
                return;
              }
            })
            .finally(() => {
              throw new Error();
            });
        }
        if (res.status !== 200) throw new Error("An error occurred");
        // The invitation exists now; whoever is showing it can go and look.
        onInvited?.();
        fetch(base_url + "user/referral/data", {
          method: "POST",
          mode: "cors",
          body: ``,
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
        })
          .then((res) => {
            console.log(res);
            return res.json();
          })
          .then((data) => {
            console.log(Object.is(data, referralData));
            setReferralData({ ...data });
          });
        console.log("No deberñia estar aquí");
        setEmailInvalid(false);
        setLoading(false);
        setInvalidEmailFormat(false);

        setNewTimeout();
      })
      .catch((err) => {
        setEmailInputTouched(false);
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      <div className={styles.section3}>
        {/* TODO: un-comment this section when email translation is ready */}
        <p className={styles.section3Text1}>
          {dublicatedcontent.dublicatedText261}
        </p>
        <form
          id="sendInvite"
          onSubmit={(e) => sendEmail(e)}
          className={styles.section3EmailContainer}
        >
          <input
            placeholder={dublicatedcontent.dublicatedText74}
            className={styles.section3EmailContainerInput}
            onChange={(e) => {
              setReferralEmail(e.target.value.trim());
            }}
            value={referralEmail}
          />
          <Button
            htmlType="submit"
            style={loading ? { width: "85px" } : {}}
            loading={loading}
            className={styles.section3EmailContainerButton}
          >
            {content.referralSection3EmailButtonText}
          </Button>

          {emailInputTouched &&
            !emailInvalid &&
            !loading &&
            !invalidEmailFormat && (
              <div className={styles.section3SuccessMessageContainer}>
                <OkSvg />
                <p>{content.referralSection3EmailSuccess}</p>
              </div>
            )}
        </form>
        {invalidEmailFormat && emailInputTouched && (
          <div className={styles.section3ErrorMessageContainer}>
            <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
            <p className={styles.section3ErrorMessageContainerMessage}>
              {content.referralSection3EmailFailedFormat}
            </p>
          </div>
        )}
        {emailInvalid && emailInputTouched && (
          <div className={styles.section3ErrorMessageContainer}>
            <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
            <p className={styles.section3ErrorMessageContainerMessage}>
              {content.referralSection3EmailFailed}
            </p>
          </div>
        )}
        {userAlreadyInvited && (
          <div className={styles.section3ErrorMessageContainer}>
            <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
            <p className={styles.section3ErrorMessageContainerMessage}>
              {dublicatedcontent.you_already_invited_this_user}
            </p>
          </div>
        )}
        <p className={styles.section3Text3}>{content.referralSection3Text3}</p>
        <div className={styles.section3ReferralLinkContainer}>
          {masterCode.map((code, i) => {
            const referral_url = code.url;
            return (
              <Fragment key={i}>
                <p className={styles.section3ReferralLink}>{referral_url}</p>
                <CopySvg
                  onClick={(e) => {
                    navigator.clipboard.writeText(referral_url);
                    setShowTextCopied(true);
                    setTimeout(() => {
                      setShowTextCopied(false);
                    }, 3000);
                  }}
                  className={styles.section3ReferralLinkContainerSvg}
                />
              </Fragment>
            );
          })}
        </div>
        {showTextCopied && (
          <div className={styles.section3ReferralLinkTextCopiedContainer}>
            <OkSvg width={20} height={20} />{" "}
            {content.referralSection3ReferralLinkCopiedMessage}
          </div>
        )}
      </div>
      <div
        className={styles.rect}
        style={{
          margin: "10px 0 25px 0",
        }}
      />
    </>
  );
}

export default ReferralCodesSection;
